import React from "react";
import backpackImg from "../Images/s-b-vonlanthen-308747-unsplash.jpg";
import { Link } from 'react-router-dom'

export default function LatestArtice() {
  return (
    <Link className="row card-body full-card-div div-zoom" to='/blog/latest'>
      <div className='img-hover-zoom col-12 col-md-6 px-0'>

      <img
        src={backpackImg}
        alt="Item"
        className="img-fluid latest-artice-photo card-img "
      />
      </div>
      <div className="col-12 col-md-6">
        <h3 className="card-title">
          What you should learn before first big travel?
        </h3>
        <p className='card-text text-justify'>
          Morbi eget faucibus mi, id rutrum enim. Pellentesque non commodo
          magna, vel euismod massa. In hac habitasse platea dictumst. Nunc
          tincidunt ornare porta. Donec vitae lorem non ante molestie finibus id
          non dui. Phasellus gravida, purus at tincidunt feugiat, arcu orci
          volutpat purus, imperdiet tempor dui lectus ...
        </p>
        <div className='w-100 text-right'>
        <Link to='/blog/latest' className='card-link'>More</Link> 
        </div>
        
      </div>
    </Link>
  );
}
